import {getAction, postAction, deleteAction, putAction, downFile} from "../service/http/api";
import common from '@/service/common'

export default {
  methods: {
    /**
     * 加载数据
     */
    loadData() {
      let para = Object.assign({},{pageIndex:this.page,pageSize:this.pageSize},this.reqParams);
      common.clearEmtryItemOfObject(para);
      getAction(this.url.list, para).then(res => {
        if (res.code === 200) {
          this.tableData = res.data.records;
          if(this.$refs.table){
            const pagination = this.$refs.table.pagination;
            pagination.total = res.data.total;
          }
        }
      })
    },
    /**
     * 搜索
     */
    onSearch() {
      this.page = 1;
      this.loadData();
    },
    /**
     * 清除搜索条件
     */
    onClearSearch() {
      Object.keys(this.reqParams).forEach(key => {
        this.reqParams[key] = null;
      });
      this.page = 1;
      this.loadData();
    },
    /**
     * 分页处理
     */
    handleChange(pagination, {currentPage, pageSize}) {
      this.pageSize = pageSize;
      this.page = currentPage;
      this.loadData();
    },
    /**
     * 导出
     */
    exportExcel(fileName) {
      downFile(this.url.download).then(res => {
        if (res) {
          this.$download(fileName, res);
        }
      })
    },

    /**
     * 弹出框编辑
     * @param row
     * @constructor
     */
    editModal(row) {
      this.currentId = row.id;
      this.editMode = 'edit';
      this.isShowEdit = true;
    },
    /**
     * 新增
     */
    addModal(name) {
      this.currentId = null;
      this.editMode = 'new';
      this.currentTitle = name;
      this.isShowEdit = true;
    },
    /**
     * 关闭'新增编辑'弹出框
     */
    onModalOk() {
      this.isShowEdit = false;
      this.currentId = null;
      this.loadData();
    },
    /**
     * 删除
     * @param rowId
     */
    remove(rowId){
      this.$confirm('确定删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        getAction(this.url.remove,{id:rowId}).then(res=>{
          if(res.code===200){
            this.$message({
              message:'删除成功',
              type:"success"
            });
            this.loadData();
          }
        })
      });
    }
  },
  created() {
    this.loadData();
  },
}



// WEBPACK FOOTER //
// ./src/mixin/tablePage.js